var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.333eb06ad5adb2603555f368494b097f.svg#form-error';
                    var viewUrl = 'sprite.333eb06ad5adb2603555f368494b097f.svg#view-form-error';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 28 28',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };